"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var CatUnterhaltung32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { fill: "currentColor", d: "M19.031 16.602s-.922-.828-2.748-.809-3.802 1.167-3.595 2.993 2.748 2.409 3.991 2.296c1.242-.113 3.012-.621 3.407-2.315l.019-8.527 8.471-1.864v6.118s-1.092-1.054-3.256-.809-3.407 1.769-2.993 3.181c.414 1.431 2.372 2.24 3.934 2.089s3.144-.847 3.407-2.447V3.877L19.033 6.211v10.391z" }),
    react_1.default.createElement("path", { d: "M8.414 24.847h15.36v1.826H8.414v-1.826zm0-13.572h9.864v1.826H8.414v-1.826z" }),
    react_1.default.createElement("path", { d: "M8.188 8.866H2.07a.258.258 0 00-.264.264v19.652c0 .151.113.264.264.264h6.118a.258.258 0 00.264-.264V9.13a.27.27 0 00-.264-.264zm-1.92 18.372H4.009a.258.258 0 01-.264-.264v-3.652c0-.151.113-.264.264-.264h2.259c.151 0 .264.113.264.264v3.652a.284.284 0 01-.264.264zm.264-6.382a.289.289 0 01-.282.282H4.01a.289.289 0 01-.282-.282v-3.614c0-.151.132-.282.282-.282h2.221c.151 0 .282.132.282.282v3.614zm0-6.174a.289.289 0 01-.282.282H4.01a.289.289 0 01-.282-.282v-3.614c0-.151.132-.282.282-.282h2.221c.151 0 .282.132.282.282v3.614zm23.548 3.106c-.527.753-.96 1.186-1.619 1.506v1.562a.289.289 0 01-.282.282h-2.221a.289.289 0 01-.282-.282v-.998a6.388 6.388 0 01-1.92-.395v9.299c0 .151.132.282.282.282h6.08a.289.289 0 00.282-.282V17.336c-.094.132-.188.282-.32.452zm-1.882 9.45h-2.259a.258.258 0 01-.264-.264v-3.652c0-.151.113-.264.264-.264h2.259c.151 0 .264.113.264.264v3.652c.019.132-.113.264-.264.264z" }))); };
var StyledCatUnterhaltung32 = styled_components_1.default(CatUnterhaltung32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCatUnterhaltung32;
var templateObject_1;
//# sourceMappingURL=CatUnterhaltung32.js.map